import axios from 'axios';
import { fileDocumentTypes } from './interfaces';
const apiURL = process.env.REACT_APP_API_URL;

export const getDocument = async (documentId: number, fileName: string) => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const extension = fileName.split('.').pop()?.toLowerCase() ?? '';
   const mimeTypes: Record<string, string> = {
      pdf: 'application/pdf',
      png: 'image/png',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      gif: 'image/gif',
      webp: 'image/webp',
      svg: 'image/svg+xml',
      txt: 'text/plain',
      html: 'text/html',
      htm: 'text/html',
   };
   const mimeType = mimeTypes[extension] ?? 'application/octet-stream';
   const isViewable = mimeType !== 'application/octet-stream';

   await axios.get(`https://${apiURL}/Files/${documentId}`, {
      responseType: 'arraybuffer',
      headers: {
         Authorization: 'Bearer ' + token,
      },
   }).then((response) => {
      const blob = new Blob([response.data], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      if (isViewable) {
         window.open(url, '_blank');
      } else {
         const link = document.createElement('a');
         link.href = url;
         link.setAttribute('download', fileName);
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
      }
      setTimeout(() => window.URL.revokeObjectURL(url), 10000);
   });
};

export const downloadDocument = async (documentId: number, fileName: string) => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   await axios.get(`https://${apiURL}/Files/${documentId}`, {
      responseType: 'arraybuffer',
      headers: {
         Authorization: 'Bearer ' + token,
      },
   }).then((response) => {
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => window.URL.revokeObjectURL(url), 10000);
   });
};


export const deleteDocument = async (id: number) => {
   const token = localStorage.getItem('authToken');

   console.log(token)

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios({
      url: `https://${apiURL}/Files/${id}`,
      method: 'delete',
      headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + token,
      }
   });

   const data = response.data;

   return data;
};

/**
 * Fetches a document with the auth header and returns an object URL for it,
 * for use as an <img> src. The caller owns the URL and must revoke it.
 */
export const getDocumentObjectUrl = async (documentId: number): Promise<string> => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios.get(`https://${apiURL}/Files/${documentId}`, {
      responseType: 'blob',
      headers: {
         Authorization: 'Bearer ' + token,
      },
   });

   return window.URL.createObjectURL(response.data);
};

/** The outcome for one PDF copied onto a job without its prices. */
export interface PriceFreeQuoteResult {
   documentId: number
   newDocumentId: number | null
   error: string | null
}

/**
 * Copies PDFs from the job's quote onto the job with their prices blacked out,
 * visible in the app. Each file succeeds or fails on its own.
 */
export const addPriceFreeQuoteCopies = async (jobId: number, documentIds: number[]): Promise<PriceFreeQuoteResult[]> => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios.post(
      `https://${apiURL}/Files/Job/${jobId}/PriceFreeQuote`,
      { documentIds },
      {
         headers: {
            Authorization: 'Bearer ' + token,
         },
      }
   );

   return response.data;
};
